import axios from "axios";
export default {
    namespaced:false,
  state: {
    fichiers: [],
    },
  getters: {
    getFichiers: (state) => {
      return state.fichiers;
    },
  },
  mutations: {
    DO_NOTHING() {},
    ADD_FICHIERS(state, payload) {
        state.fichiers = payload;
      },
  },
  actions: {
    getAllAlerts({ commit }) {
        axios
          .get(
            "https://testt-d63b1.firebaseio.com/fichier.json" 
          )
          .then((response) => {
            const data = response.data;
            const fichiers = [];
            for (let key in data) {
                const fichier = data[key];
                fichier.id = key;
                fichiers.push(fichier);
              
            }
            commit("ADD_FICHIERS", fichiers);
          });
      },
 
  async removeFichiers( { commit },payload) {
    try {
      const responce = await axios.delete(
        "https://testt-d63b1.firebaseio.com/fichier" +
          payload.id 
      );
      commit("DO_NOTHING");
      //commit("REMOVE_ALERT", payload);
      return responce
    } catch (error) {
      return null;
    }
  },
},
};
